class ProductGridAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.addToCartButton = "";
    this.variantID = "";
    this.popdown = document.querySelector("[data-product-add-popdown-wrapper]");

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e){
    console.log (this.form + "was submitted with event: " + e );
    e.preventDefault();
    const formData = new FormData(this.form);
    this.variantID = formData.get('id');

    fetch(`${window.theme.routes.cart}/add.js`, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      console.log (response);
      return response.json();
    }).then(data => {
      console.log(data);
      console.log ('fire popdown event');
      this.popdown.dispatchEvent(
        new CustomEvent('theme:cart:popdown', {
          detail: {
            variant: data,
          },
          bubbles: true,
        })
      );

      this.updateHeaderCartIcon();

      return;
    })
    .catch((error) => {
      console.error('Error:', error);
       //handle errors
    });
  }

  updateHeaderCartIcon(){
    fetch(`${window.theme.routes.cart}.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response =>{
      return response.json();
    })
    .then(data => {
      console.log(data);
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          detail: {
            cart: data,
          },
          bubbles: true,
        })
      );
    })
  }

  buttonIdentifier() {
    if (this.querySelector('button[name=add]')) {
      this.addToCartButton = this.querySelector('button[name=add]');
      this.variantID = this.querySelector('input[name=id]').value;
      this.addToCartButton.addEventListener('click',()=>{
          console.log(this.variantID);
          this.popdown.dispatchEvent(
            new CustomEvent('theme:cart:popdown', {
              detail: {
                variant: this.variantID,
              },
              bubbles: true,
            })
          );
      });
    }
 }
}

customElements.define('product-grid-add-to-cart', ProductGridAddToCart);